import { useMemo } from 'react'
import { useGrowthBookValues } from '../contexts/GrowthBookContext'

export const useGBValue = () => {
  const {
    paywallTheme,
    animatedPictures,
    steps,
    attributeSelectionStyle,
    magicLink,
  } = useGrowthBookValues()

  const ab_testing = useMemo(
    () => ({
      'createsexfriends-paywall-theme': paywallTheme,
      'createsexfriend-animated-pictures': animatedPictures,
      'createsexfriend-steps': steps,
      'createsexfriend-attribute-selection-style': attributeSelectionStyle,
      'createsexfriends-gray-magicLink': magicLink,
    }),
    [paywallTheme, animatedPictures, steps, attributeSelectionStyle, magicLink],
  )

  return ab_testing
}
